import React from "react";
import HomeContainer from "./HomeContainer";

const HomePage = props => <HomeContainer {...props} />;

export default HomePage;



// WEBPACK FOOTER //
// ./components/inAppMessages/HomePage.js